import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid-services-new',
  templateUrl: './covid-services-new.component.html',
  styleUrls: ['./covid-services-new.component.less']
})
export class CovidServicesNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
